import BaseButton from '@bnnvara/buttons/src/components/BaseButton/BaseButton';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';
import { Summary } from './Summary';

export const PaymentStep = ({ isLoading, paymentUrl, message, data }) => {
  return (
    <S.PaymentStep>
      {isLoading && <p>Gegevens ophalen...</p>}
      {!isLoading && paymentUrl !== undefined && (
        <>
          <Summary {...data} />
          <BaseButton type="link" href={paymentUrl} fullWidth>
            Ga naar betalen
          </BaseButton>
        </>
      )}
      {!isLoading && paymentUrl === undefined && <p>{message}</p>}
    </S.PaymentStep>
  );
};
PaymentStep.defaultProps = {
  isLoading: true,
};
PaymentStep.propTypes = {
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  paymentUrl: PropTypes.string,
  data: PropTypes.shape({
    initials: PropTypes.string,
    firstName: PropTypes.string,
    nameAffix: PropTypes.string,
    lastName: PropTypes.string,
    gender: PropTypes.string,
    dateOfBirth: PropTypes.string,
    postalCode: PropTypes.string,
    houseNumber: PropTypes.number,
    houseNumberAddition: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    emailAddress: PropTypes.string,
    phoneNumber: PropTypes.string,
    newsletterSubscription: PropTypes.string,
    membership: PropTypes.string,
  }),
};
